<template>
  <a-row>
    <a-col span="8" offset="10" v-if="loading">
      <a-spin tip="Cargando..." />
    </a-col>
    <div v-else class="col-lg-12">
      <a-row class="pb-2">
        <a-col :sm="{ span: 12, offset: 12 }" :lg="{ span: 2, offset: 22 }" class='pl-1'>
          <router-link to="/carta_porte/principal" style="width: 100%" class="btn bg-holcim-bright-blue">
            <i class="fe fe-arrow-left" />
          </router-link>
        </a-col>
      </a-row>

      <embed :src="pdfFileUrl" width="100%" height="1800px" frameBorder="0" scrolling="auto" class="text-center"
        type="application/pdf" />
    </div>
  </a-row>
</template>

<script>
import { ref } from "vue";
import { useRoute } from "vue-router";

export default {
  name: "FileConsignmentNote",
  setup() {
    const route = useRoute();
    const routeParams = route.params;
    const { consignmentNoteId } = routeParams;
    const loading = ref(true);
    // Use environment variable for API base URL
    const pdfFileUrl = ref(`${process.env.VUE_APP_API_BASE_URL}/consignment-files/simple-pdf`);

    const getPdf = async () => {
      pdfFileUrl.value = `${pdfFileUrl.value}/${consignmentNoteId}`;
      loading.value = false;
    }
    getPdf();
    return { loading, pdfFileUrl };
  },
}
</script>
